import { Box } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./OrDivider.module.css";

export type OrDividerProps = Record<string, never>;

/** «эсвэл» — хоёр зурааны дунд. */
export function OrDivider() {
  const { t } = useTranslation("common");
  return (
    <Box className={classes.root}>
      <Box component="span" className={classes.line} />
      {t("common.or")}
      <Box component="span" className={classes.line} />
    </Box>
  );
}
